







































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
 ;
import { User } from "@/types";

@Component({
    components: {},
    computed: { ...mapGetters(["user"]) },
})
export default class MessageList extends Vue {

    private user!: User;
    mounted() {

    }
}
